import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import mantineTheme from "./mantine";

interface IMantineProvidersProps {
  children: React.ReactNode;
}

const MantineProviders: React.FC<IMantineProvidersProps> = ({ children }) => (
  <MantineProvider theme={mantineTheme}>
    <ModalsProvider>
      <Notifications position="top-right" zIndex={1_000} />
      {children}
    </ModalsProvider>
  </MantineProvider>
);

export default MantineProviders;
